module.exports = __webpack_public_path__ + "img/cklogo.b874c9d7.png";